import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../layout/DashboardLayout';
import citadelLogo from '../../assets/citadelogo.png';
import '../../styles/DashboardHome.css';

const DashboardHome = () => {
  const navigate = useNavigate();


  return (
    <DashboardLayout pageTitle="Dashboard">
      <div className="dashboard-logo-section">
        <img src={citadelLogo} alt="Citadel of Grace Logo" className="dashboard-clinic-logo" />
        <div className="dashboard-slogan">A Place of Healing, Care, and Grace.</div>
      </div>
      <div className="dashboard-quick-access">
        <div className="quick-access-card clickable" onClick={() => navigate('/dashboard/messages')}>
          <span className="quick-access-icon">💬</span>
          <div>
            <div className="quick-access-title">Communicate</div>
            <div className="quick-access-desc">Message colleagues from different departments</div>
          </div>
        </div>
        <div className="quick-access-card clickable" onClick={() => navigate('/dashboard/files')}>
          <span className="quick-access-icon">📁</span>
          <div>
            <div className="quick-access-title">Share Files</div>
            <div className="quick-access-desc">Upload and share files securely</div>
          </div>
        </div>
        <div className="quick-access-card clickable" onClick={() => navigate('/dashboard/staff')}>
          <span className="quick-access-icon">👥</span>
          <div>
            <div className="quick-access-title">Staff Directory</div>
            <div className="quick-access-desc">Find and manage staff accounts</div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default DashboardHome; 